module.exports = __webpack_public_path__ + "static/img/ex_logo_10.7128206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ex/ex_logo_10.jpg
// module id = KN4N
// module chunks = 0